export const k8Scopes = {
  ENDPOINT: 'Endpoint',
  SERVICE_INSTANCE: 'ServiceInstance',
  SERVICE: 'Service'
};
export const DELIMITER = ':::';